import React, { useState } from 'react';

/**
 * IdentityVerifyNotice — กล่องชี้แจงการยืนยันตัวตนด้วยรูป บนหน้าสมัครบัญชี / ขอรหัสผ่านใหม่
 *   requireFacePhoto = true  → ต้องแนบ 2 รูป (ถือบัตร + บัตร)
 *                      false → แนบรูปบัตรอย่างเดียว
 * มีส่วน "ทำไมต้องขอรูป" พับ/กางได้ และช่องทางติดต่อด้วยตนเองสำหรับคนที่ไม่สะดวก
 */
function IdentityVerifyNotice({ requireFacePhoto }) {
    const [whyOpen, setWhyOpen] = useState(false);
    return (
        <div className="idcard-instruction" style={{ borderLeft: '4px solid #d97706', background: 'rgba(217,119,6,0.08)' }}>
            <strong>🛡️ การยืนยันตัวตน — {requireFacePhoto ? 'ต้องแนบรูป 2 รูป' : 'ต้องแนบรูปบัตรประชาชน'}</strong>
            <div style={{ marginTop: 4 }}>
                {requireFacePhoto ? (
                    <>
                        1. รูปถ่ายตนเอง<b>ถือบัตรประชาชน</b> (หันด้านหน้าบัตรเข้ากล้อง) ให้เห็นใบหน้าและข้อมูลในบัตรชัดเจน<br />
                        2. รูป<b>ด้านหน้าบัตรประชาชน</b> เฉพาะบัตร เพื่อตรวจความถูกต้องของข้อมูล — <b>ไม่ใช่ด้านหลังบัตร</b>
                    </>
                ) : (
                    <>รูป<b>ด้านหน้าบัตรประชาชน</b> (ด้านที่มีรูปหน้าและเลข 13 หลัก) ถ่ายให้ชัด — <b>ไม่ใช่ด้านหลังบัตร</b></>
                )}
            </div>

            <div style={{ marginTop: 8, padding: '8px 10px', background: 'rgba(255,255,255,0.7)', borderRadius: 8, fontSize: 13 }}>
                <b>ไม่สะดวกถ่ายรูป{requireFacePhoto ? 'คู่กับบัตร หรือถ่ายบัตร' : 'บัตร'}?</b>{' '}
                ติดต่อด้วยตนเองได้ที่ <b>กลุ่มงานการเงิน อาคาร OPD ชั้น 4</b> (เวลาราชการ) พร้อมบัตรประชาชนตัวจริง
                เจ้าหน้าที่จะยืนยันตัวตนและเปิดใช้งานให้
            </div>

            <button
                type="button"
                onClick={() => setWhyOpen((v) => !v)}
                style={{ marginTop: 8, background: 'none', border: 'none', padding: 0, color: '#92400e', fontSize: 12.5, textDecoration: 'underline', cursor: 'pointer' }}
            >
                {whyOpen ? '▾' : '▸'} ทำไมต้องขอรูป{requireFacePhoto ? 'ถ่ายคู่กับบัตร' : 'บัตร'}?
            </button>
            {whyOpen && (
                <div style={{ marginTop: 6, fontSize: 12.5, lineHeight: 1.7, opacity: 0.9 }}>
                    ระบบนี้เปิดดู<b>เงินเดือน ภาษี และเอกสารทางการเงินส่วนตัว</b>ของท่านได้ทั้งหมด
                    เลขบัตรหรือสำเนาบัตรเพียงอย่างเดียวรั่วไหลได้ง่าย (เคยถ่ายเอกสารให้หน่วยงานต่างๆ)
                    หากใครมีสำเนาบัตรของท่านก็อาจสมัครแทนแล้วเห็นข้อมูลเงินเดือนของท่านได้
                    {requireFacePhoto ? (
                        <> รูปถ่ายคู่กับบัตรพิสูจน์ว่า<b>เจ้าของบัตรตัวจริงเป็นผู้ยื่นเอง ณ เวลานั้น</b> ซึ่งสำเนาบัตรทำแทนไม่ได้
                            — วิธีเดียวกับที่ธนาคาร แอปกระเป๋าเงิน และหน่วยงานรัฐใช้เปิดบัญชีออนไลน์ (e-KYC) ตามแนวทางของธนาคารแห่งประเทศไทย</>
                    ) : (
                        <> รูปบัตรที่ถ่ายใหม่ใช้ยืนยันว่าข้อมูลที่กรอกตรงกับบัตร และเจ้าหน้าที่จะเทียบกับข้อมูลบุคลากรก่อนเปิดใช้งาน</>
                    )}
                    <br />
                    รูปถูกเก็บในพื้นที่ปิด ไม่เผยแพร่สาธารณะ เข้าถึงได้เฉพาะเจ้าหน้าที่การเงินที่ได้รับสิทธิ์ และใช้เพื่อยืนยันตัวตนเท่านั้น
                    หากรูปไม่ครบถ้วน/ไม่ชัดเจน ขอสงวนสิทธิ์ปฏิเสธคำขอ
                </div>
            )}
        </div>
    );
}

export default IdentityVerifyNotice;
